// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhr_a bih_ea bih_a","LoadingSwitch__init":"bhr_b bih_a bih_w bih_j bih_ul bih_um bih_fm"};